import { useEffect, useRef } from 'react';
import { attach, detach, setActiveAsset } from '../renderer/rendererBridge';
import { terminateWorker } from '../engine/ffmpegBridge';
import { useEditorStore } from '../store/editorStore';
import { hasAssetData } from '../engine/proxyManager';

export function useEditorInit(canvasRef: React.RefObject<HTMLCanvasElement | null>) {
  const initialized = useRef(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || initialized.current) return;

    initialized.current = true;
    attach(canvas);

    // After renderer is ready, init decoder for the first asset with proxy data
    initFirstAsset();

    return () => {
      initialized.current = false;
      detach();
      terminateWorker();
    };
  }, [canvasRef]);
}

async function initFirstAsset() {
  const assets = useEditorStore.getState().project.assets;
  for (const asset of assets) {
    if (asset.ingestStatus !== 'ready') continue;
    const exists = await hasAssetData(asset.id);
    if (exists) {
      try {
        await setActiveAsset(asset.id);
      } catch (err) {
        console.warn('Failed to init asset after attach:', err);
      }
      break;
    }
  }
}
